/* eslint-disable */
import _ from 'lodash'
import React from 'react'
import { PropTypes } from 'prop-types'
import { Row, Col,Button } from 'react-bootstrap'
import ReactTable from 'react-table'
import { postAthletes } from './api'
import styles from './styles'
import {  warning } from '../../../utils/constants'
// Import React Table

import 'react-table/react-table.css'
import ContentWrapper from '../../layout/ContentWrapper'

class Athletes extends React.Component {
  constructor() {
    super()
    this.state = {
      data:[],
      saving:false,
      prestine:false,
      changedRecords:[],
      saved:false,
      //showAthletes:true
    }
    this.renderEditable    = this.renderEditable.bind(this)
    this.handleSaveAthlete = this.handleSaveAthlete.bind(this)
  }
  componentDidMount()
  {
    const { bowlers } = this.props
    let data =  bowlers.map(item => Object.assign({}, item))
    this.setState({data})
    /* this page reflects one instance of a bowler/tournament state.
       This may mislead the user to assume that a.) the name/bowler-id 
       values are in sync across all tournaments or
       b.) 'save' request updated a record that was not flagged as changed. 
       We are flaging all records "changed" to ensure all bowler data/torunament
       instances are updated.
    */
    this.setState({changedRecords:data})  
  }

  UNSAFE_componentWillReceiveProps() {
   this.setState({saved:false})
  }
  renderEditable(cellInfo) {
    return (
      <div
        style={{ backgroundColor: "#fafafa" }}
        contentEditable
        suppressContentEditableWarning
        onBlur = { e => {
          console.log('Control lost focus')
          const data = [...this.state.data]
          const { bowlers } = this.props
          const changedRecords = [...this.state.changedRecords]
          const row = cellInfo.index
          const id = this.state.data[row].id
          data[row][cellInfo.column.id] = e.target.innerHTML
          data[row].UpdateType = 0
          // add record only once
          if((bowlers[row].bowlerName !== data[row].bowlerName) ||
             (bowlers[row].bowlerId !== data[row].bowlerId)) 
          {
            
            const exists = _.find(changedRecords,['id',id])
            
            if (exists === undefined) 
            {
              changedRecords.push(this.state.data[row])
            }
          }
        
          this.setState({ data,prestine:false,changedRecords })
        }}
        dangerouslySetInnerHTML={{
          __html: this.state.data[cellInfo.index][cellInfo.column.id]
        }}
      />
    )
  }
  handleSaveAthlete()
  {
    const { changedRecords, prestine } = this.state
    const { token } = this.props
    const _this = this
   
    if(!prestine)
    {
      this.setState({
        saving:true,
        saved:false
      })
  
      const updates = {
        Athletes: changedRecords
      }
      postAthletes(updates,token).then(function()
      {
        _this.setState({
          saving:false,
          prestine:true,
          saved:true,
          //showAthletes:false
        })
      })
    }
  }
  render() {
    const { 
      data,
      saving,
      showAthletes,
      prestine,
      saved ,
      changedRecords
    }  = this.state


    const nbrAthletes = data.length
    const saveIcon    = saving ? 'fa fa-spinner fa-spin':'fa fa-user'
  

    return (
      <div style={{ marginLeft:'20px'}} sm={4}>
        <Row>
          <Col sm={4}  style={{paddingLeft:'40px'}}>
            { nbrAthletes > 0 && (!saved) &&
              (<ReactTable
                data={data}
                columns=
                  {[
                    {
                      Header: "Name",
                      accessor: "bowlerName",
                      Cell: this.renderEditable,
                      headerStyle: styles.tableHeader
                    },
                    {
                      Header: "Member ID",
                      id: "bowlerId",
                      Cell: this.renderEditable,
                      headerStyle: styles.tableHeader
                    }
                  ]}
                pageSizeOptions = {[nbrAthletes,20,25,30]}
                defaultPageSize = {nbrAthletes}
                showPagination ={ false}
                className = "-striped"
              />)
            }
          </Col>
        </Row>
        <Row>
          <Col sm={6}  style={{paddingLeft:'40px'}}>
            { !saved && (<Button className='btn-default' style={styles.saveButton} onClick={this.handleSaveAthlete} /* disabled={prestine} */> 
              <i className={saveIcon} aria-hidden="true" />&nbsp;&nbsp;Save Changes
            </Button>)
            }
        
            {
              saved && (
               <div>
                <span style={{ color:warning}}> 
                  <i className='fa fa-info-circle' aria-hidden="true" />&nbsp;&nbsp;Athlete information successfully saved
                </span>
               </div> 
              )
            }
          </Col>
        </Row>
      </div>  
    )
  }
}
Athletes.propTypes = {
  bowlers: PropTypes.array,
  token: PropTypes.string
}
export default Athletes




// WEBPACK FOOTER //
// ./src/components/pages/Athlete/profile.js